<script setup lang="ts">import { ref as _ref, computed as _computed } from 'vue';

import {LocaleType} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/enum/LocaleType'
import ChooseComponent from '@toolify/client/src/modules/list/components/ChooseComponent.vue'
import ChooseItemComponent from '@toolify/client/src/modules/list/components/ChooseItemComponent.vue'
import FlagComponent from '@toolify/client/src/modules/internalization/components/FlagComponent.vue'
import {LocaleTypeItems} from '@toolify/client/src/modules/internalization/constants/LocaleTypeItems'


interface Props {
  selectedLocale: LocaleType
}

interface Emits {
  (e: 'choose', locale: LocaleType): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const localeSearch = _ref('')

const items = _computed(() => {
  const query = localeSearch.value.trim().toLowerCase()
  return LocaleTypeItems
    .filter(localeItem => {
      if(!query) {
        return true
      }
      return localeItem.title.toLowerCase().includes(query)
        || localeItem.localeType.toLowerCase().includes(query)
    })
    .map(localeItem => ({
      id: localeItem.localeType,
      title: localeItem.title,
      alphaCode: localeItem.flagAlphaCode,
    }))
})

const onChooseItem = (index: number) => {
  const item = items.value[index]
  if(item) {
    emit('choose', item.id)
  }
}
</script>

<template>
  <ChooseComponent
    :items="items"
    :selectedIndexes="[items.findIndex(item => item.id === props.selectedLocale)]"
    :search="localeSearch"
    allowChoose
    @update:search="value => localeSearch = value"
    @chooseItem="onChooseItem"
  >
    <template #item="{item, isSelected, itemHeight}">
      <ChooseItemComponent :isSelected="isSelected" :itemHeight="itemHeight">
        <template #left>
          <FlagComponent :alphaCode="item.alphaCode" :width="20"/>
        </template>
        {{item.title}}
      </ChooseItemComponent>
    </template>
  </ChooseComponent>
</template>
